export const NARROW_INPUT_WIDTH = '217px'

export const SHOW_PREVIEW_TO_SIDE_MIN_WIDTH: string = '68.75em' // 1100px
